import { int32ToString, equals, comparePrimitives, defaultOf, createObj, uncurry2, compare } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { toUtcString, parseDateIso8601 } from "./Utils.js";
import { now, timeOfDay, date as date_2, op_Addition, day, month, year, create } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { bind, toArray, unwrap, defaultArg, some, map } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { Activity_$reflection, Activity } from "./Shared/ApiDataTypes.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { cons, ofArray, empty, singleton } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { string_type, int32_type, obj_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Route_fetchRoutes, Vessels_fetchTimelineVessels, mapFetchError } from "./Promises.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { MenuItem, Select, InputLabel, FormControl, TextField, Autocomplete, IconButton, DialogActions, Button, DialogContent, Typography, DialogTitle, Dialog, Checkbox, FormControlLabel } from "@mui/material";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { iterate, empty as empty_1, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { Mobiscroll_inputOptions, Mbs_DatePicker } from "./Feliz.Mobiscroll.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { globalCtx } from "./Context.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { sortBy, map as map_1, tryFind } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { ErrorHandling_errorBanner, wrapTooltip } from "./ViewHelpers.js";
import Delete from "@mui/icons-material/Delete";
import { HistoricState__get_ColorCode, HistoricState_CalculateFromDates, Activity_ActivityType_AllActivityTypes, Activity_ActivityType__get_Id, Role, Role__get_Identifier } from "./Shared/Shared.js";
import { toString as toString_1 } from "./fable_modules/fable-library-js.4.24.0/Types.js";

function validateActivity(a) {
    if ((a.VesselId > 0) && (a.RouteId > 0)) {
        if (a.ToDate == null) {
            return true;
        }
        else {
            return compare(a.FromDate, a.ToDate) <= 0;
        }
    }
    else {
        return false;
    }
}

function setWholeDay(activity) {
    let date;
    return new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, (date = parseDateIso8601(activity.FromDate), toUtcString(create(year(date), month(date), day(date), 0, 0, 0))), map((dateStr) => {
        const date_1 = parseDateIso8601(dateStr);
        return toUtcString(create(year(date_1), month(date_1), day(date_1), 23, 59, 59));
    }, activity.ToDate), activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType);
}

export const canonicalizeDateTimeStr = (arg) => toUtcString(parseDateIso8601(arg));

function updateActivity(activity, callback) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, body, decoder, data_1, caseStrategy_3, extra_3;
        let activity$0027;
        if (activity.WholeDay) {
            activity$0027 = setWholeDay(activity);
        }
        else {
            const toDate = map(canonicalizeDateTimeStr, activity.ToDate);
            activity$0027 = (new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, canonicalizeDateTimeStr(activity.FromDate), toDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
        }
        return ((pr_1 = ((body = Auto_generateBoxedEncoder_437914C6(Activity_$reflection(), undefined, undefined, undefined)(activity$0027), (decoder = Auto_generateBoxedDecoder_Z6670B51(Activity_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/activity", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Activity_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })())))))), pr_1.then(mapFetchError))).then((_arg_2) => {
            callback(_arg_2);
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function createActivity(activity, callback) {
    let activity$0027;
    if (activity.WholeDay) {
        activity$0027 = setWholeDay(activity);
    }
    else {
        const toDate = map(canonicalizeDateTimeStr, activity.ToDate);
        activity$0027 = (new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, canonicalizeDateTimeStr(activity.FromDate), toDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
    }
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, body, decoder, data_1, caseStrategy_3, extra_3;
        return ((pr_1 = ((body = Auto_generateBoxedEncoder_437914C6(Activity_$reflection(), undefined, undefined, undefined)(activity$0027), (decoder = Auto_generateBoxedDecoder_Z6670B51(Activity_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/activity", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Activity_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })())))))), pr_1.then(mapFetchError))).then((_arg_2) => {
            callback(_arg_2);
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function tryDeleteActivity(activityId, callback) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(int32_type, undefined, undefined), (data_1 = "", (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(string_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/activity/${activityId}`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(int32_type, unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then(mapFetchError))).then((_arg_2) => {
            callback(_arg_2);
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function commonCheckBox(label, value, onCheck) {
    return MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", label], ["control", MuiHelpers_createElement(Checkbox, [["checked", value], ["color", "primary"], ["onChange", (e) => {
        onCheck(e.target.checked);
    }]])]]);
}

export function DateRangePicker(dateRangePickerInputProps) {
    let elems_2, elems, elems_1;
    const setValue = dateRangePickerInputProps.setValue;
    const activity = dateRangePickerInputProps.activity;
    const toDate = dateRangePickerInputProps.toDate;
    const fromDate = dateRangePickerInputProps.fromDate;
    const wholeDay = dateRangePickerInputProps.wholeDay;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-evenly",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
    }], (elems = toList(delay(() => append(singleton_1(Mbs_DatePicker([["controls", ["calendar"]], ["value", fromDate], ["dateFormat", "DD. MMMM YYYY"], ["onChange", (e) => {
        let y;
        const newFromDate = e.value;
        setValue(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, (toDate == null) ? toUtcString(newFromDate) : ((y = toDate, toUtcString(op_Addition(date_2(newFromDate), timeOfDay(y))))), activity.ToDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
    }], ["inputProps", Mobiscroll_inputOptions([["cssClass", "mbs-normal-size-input"], ["inputStyle", "underline"], ["label", "Fra dato"]])]])), delay(() => (!wholeDay ? singleton_1(Mbs_DatePicker([["controls", ["time"]], ["value", fromDate], ["stepMinute", 15], ["onChange", (e_1) => {
        const time = e_1.value;
        setValue(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, toUtcString(op_Addition(date_2(fromDate), timeOfDay(time))), activity.ToDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
    }], ["inputProps", Mobiscroll_inputOptions([["cssClass", "mbs-normal-size-input"], ["inputStyle", "underline"], ["label", "Tid"]])]])) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
    }], (elems_1 = toList(delay(() => append(singleton_1(Mbs_DatePicker([["controls", ["calendar"]], ["value", defaultArg(toDate, defaultOf())], ["dateFormat", "DD. MMMM YYYY"], ["onChange", (e_2) => {
        let y_1;
        const newToDate = e_2.value;
        setValue(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, activity.FromDate, (toDate == null) ? toUtcString(newToDate) : ((y_1 = toDate, toUtcString(op_Addition(date_2(newToDate), timeOfDay(y_1))))), activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
    }], ["inputProps", Mobiscroll_inputOptions([["cssClass", "mbs-normal-size-input"], ["inputStyle", "underline"], ["label", "Til dato"]])]])), delay(() => (!wholeDay ? singleton_1(Mbs_DatePicker([["controls", ["time"]], ["value", defaultArg(toDate, defaultOf())], ["stepMinute", 15], ["onChange", (e_3) => {
        const time_1 = e_3.value;
        setValue(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, activity.FromDate, (toDate == null) ? undefined : toUtcString(op_Addition(date_2(toDate), timeOfDay(time_1))), activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
    }], ["inputProps", Mobiscroll_inputOptions([["cssClass", "mbs-normal-size-input"], ["inputStyle", "underline"], ["label", "Tid"]])]])) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

/**
 * Selfcontained add and edit modal.
 * If editActivity is Some, will allow edit of that activity.
 * Otherwise will create a new activity,
 * using the optional default values to select route and or vessel on init.
 */
export function ActivityModal(activityModalInputProps) {
    const routes$0027 = activityModalInputProps["routes\'"];
    const vessels$0027 = activityModalInputProps["vessels\'"];
    const onActivityDelete = activityModalInputProps.onActivityDelete;
    const onClose = activityModalInputProps.onClose;
    const defaultStartTime = activityModalInputProps.defaultStartTime;
    const defaultRouteId = activityModalInputProps.defaultRouteId;
    const defaultVesselId = activityModalInputProps.defaultVesselId;
    const editActivityOpt = activityModalInputProps.editActivityOpt;
    let patternInput;
    const matchValue = reactApi.useContext(globalCtx).Session;
    if (matchValue != null) {
        const s = matchValue;
        patternInput = [s.Roles, s.IsSuperAdmin];
    }
    else {
        patternInput = [[], false];
    }
    const roles = patternInput[0];
    const isSuperAdmin = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setConfirmDelete = patternInput_1[1];
    const patternInput_2 = reactApi.useState(vessels$0027);
    const vessels = patternInput_2[0];
    const patternInput_3 = reactApi.useState(routes$0027);
    const routes = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setError = patternInput_4[1];
    const error = patternInput_4[0];
    let patternInput_5;
    const initial_4 = defaultArg(editActivityOpt, new Activity(-1, defaultArg(defaultVesselId, -1), defaultArg(defaultRouteId, -1), false, defaultArg(defaultStartTime, toUtcString(date_2(now()))), undefined, "", false, true, undefined));
    patternInput_5 = reactApi.useState(initial_4);
    const setActivity = patternInput_5[1];
    const activity = patternInput_5[0];
    const dependencies = [editActivityOpt];
    reactApi.useEffect(() => {
        iterate(setActivity, toArray(editActivityOpt));
    }, dependencies);
    useEffectOnce(() => {
        if (vessels$0027 == null) {
            Vessels_fetchTimelineVessels((_arg_2) => {
                if (_arg_2.tag === 0) {
                    patternInput_2[1](_arg_2.fields[0]);
                }
                else {
                    const e = _arg_2.fields[0];
                    console.error(some("fetching vessels error"), e);
                    setError(e);
                }
            });
        }
        if (routes$0027 == null) {
            Route_fetchRoutes((_arg_3) => {
                if (_arg_3.tag === 0) {
                    patternInput_3[1](_arg_3.fields[0]);
                }
                else {
                    const e_1 = _arg_3.fields[0];
                    console.error(some("fetching vessels error"), e_1);
                    setError(e_1);
                }
            });
        }
    });
    return MuiHelpers_createElement(Dialog, toList(delay(() => append(singleton_1(["open", true]), delay(() => append(singleton_1(["onClose", (_arg_5, v) => {
        onClose(undefined);
    }]), delay(() => append(singleton_1(["PaperProps", {
        style: {
            width: 100 + "%",
            maxWidth: 450,
            minWidth: 250,
        },
    }]), delay(() => {
        let matchValue_1, a;
        return append((matchValue_1 = editActivityOpt, (matchValue_1 != null) ? ((a = matchValue_1, singleton_1(["key", `activity-${defaultArg(map((a$0027) => (`-${a$0027}`), a.ToDate), "")}-${a.Id}`]))) : (empty_1())), delay(() => {
            let elems_12;
            return singleton_1((elems_12 = toList(delay(() => {
                let elems_4;
                return patternInput_1[0] ? append(singleton_1(MuiHelpers_createElement(DialogTitle, [["children", "Vennligst bekreft handling"]])), delay(() => {
                    let children;
                    return append(singleton_1((children = toList(delay(() => {
                        const vessel = bind((array) => tryFind((x_2) => (x_2.Id === activity.VesselId), array), vessels);
                        const route = bind((array_1) => tryFind((x_3) => (x_3.Id === activity.RouteId), array_1), routes);
                        return append(singleton_1(MuiHelpers_createElement(Typography, [["children", `Bekreft at du vil fjerne aktiviteten: ${activity.InfoText}.`]])), delay(() => {
                            let matchResult, r, v_1;
                            if (vessel != null) {
                                if (route != null) {
                                    matchResult = 1;
                                    r = route;
                                    v_1 = vessel;
                                }
                                else {
                                    matchResult = 0;
                                }
                            }
                            else {
                                matchResult = 0;
                            }
                            switch (matchResult) {
                                case 0: {
                                    return empty_1();
                                }
                                default:
                                    return singleton_1(MuiHelpers_createElement(Typography, [["children", `Dette vil fjerne den fra både fartøyet: ${v_1.Name} og sambandet: ${r.Name}.`]]));
                            }
                        }));
                    })), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]]))), delay(() => {
                        let children_1;
                        return singleton_1((children_1 = ofArray([MuiHelpers_createElement(Button, [["variant", "outlined"], ["children", "avbryt"], ["onClick", (_arg_6) => {
                            setConfirmDelete(false);
                        }]]), MuiHelpers_createElement(Button, [["children", "Lagre"], ["onClick", (_arg_7) => {
                            tryDeleteActivity(activity.Id, (_arg_8) => {
                                if (_arg_8.tag === 0) {
                                    setConfirmDelete(false);
                                    if (onActivityDelete != null) {
                                        onActivityDelete(_arg_8.fields[0]);
                                    }
                                }
                                else {
                                    setError(_arg_8.fields[0]);
                                    setConfirmDelete(false);
                                }
                            });
                        }]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]])));
                    }));
                })) : append(singleton_1(MuiHelpers_createElement(DialogTitle, [(elems_4 = toList(delay(() => {
                    let elems_3, elements_2, props_5;
                    return (editActivityOpt != null) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }], (elems_3 = [MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", "Rediger aktivitet"]]), wrapTooltip("Slett aktiviteten.", MuiHelpers_createElement(IconButton, [["onClick", (_arg_9) => {
                        setConfirmDelete(true);
                    }], (elements_2 = [(props_5 = {}, react.createElement(Delete, props_5))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : singleton_1(MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", "Legg til aktivitet"]]));
                })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])), delay(() => {
                    let elems_10;
                    return append(singleton_1(MuiHelpers_createElement(DialogContent, [["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 10 + "px ",
                    }], (elems_10 = toList(delay(() => {
                        let matchValue_3, routeOptions, array_3, selectedRoute;
                        return append((matchValue_3 = routes, (matchValue_3 != null) ? ((routeOptions = map_1((x_8) => [x_8.Id, x_8.Name], sortBy((x_6) => x_6.Name, (array_3 = matchValue_3, array_3.filter((x_5) => {
                            if (isSuperAdmin) {
                                return true;
                            }
                            else {
                                return roles.some((r_2) => {
                                    if (r_2.CompanyId === x_5.CompanyId) {
                                        if (r_2.RoleId === Role__get_Identifier(new Role(3, []))) {
                                            return true;
                                        }
                                        else {
                                            return r_2.RoleId === Role__get_Identifier(new Role(6, []));
                                        }
                                    }
                                    else {
                                        return false;
                                    }
                                });
                            }
                        })), {
                            Compare: comparePrimitives,
                        })), (selectedRoute = tryFind((tupledArg) => (tupledArg[0] === activity.RouteId), routeOptions), append(singleton_1(MuiHelpers_createElement(Autocomplete, [["noOptionsText", "Ingen samband"], ["disabled", routeOptions.length === 0], ["openOnFocus", true], ["selectOnFocus", true], ["clearOnBlur", true], ["handleHomeEndKeys", true], ["options", Array.from(routeOptions)], ["isOptionEqualToValue", (x_9) => ((y_1) => equals(x_9[0], y_1[0]))], ["getOptionLabel", (tuple) => tuple[1]], ["style", {
                            flexGrow: 1,
                            maxWidth: 400,
                            marginTop: 5,
                        }], ["value", selectedRoute], ["onChange", (_arg_10, v_2, _arg_1_1) => {
                            const newActivity = new Activity(activity.Id, activity.VesselId, defaultArg(map((tuple_1) => tuple_1[0], v_2), -1), activity.WholeDay, activity.FromDate, activity.ToDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType);
                            setActivity(newActivity);
                            if (validateActivity(newActivity)) {
                                setError(undefined);
                            }
                        }], ["renderInput", (p) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p), delay(() => append(singleton_1(["required", true]), delay(() => append(singleton_1(["error", (error != null) && (activity.RouteId < 0)]), delay(() => append(singleton_1(["variant", "outlined"]), delay(() => append(singleton_1(["color", "primary"]), delay(() => singleton_1(["label", "Samband"]))))))))))))))]])), delay(() => (!isSuperAdmin ? singleton_1(createElement("span", {
                            style: {
                                fontStyle: "italic",
                                fontSize: 0.85 + "rem",
                            },
                            children: "Du kan kun registrere aktiviteter for samband hvor du har rollen Driftspersonell i selskapet",
                        })) : empty_1())))))) : (empty_1())), delay(() => {
                            let matchValue_4, vesselOptions, array_8, selectedVessel;
                            return append((matchValue_4 = vessels, (matchValue_4 != null) ? ((vesselOptions = map_1((x_14) => [x_14.Id, x_14.Name], sortBy((x_12) => x_12.Name, (array_8 = matchValue_4, array_8.filter((x_11) => {
                                if (isSuperAdmin) {
                                    return true;
                                }
                                else {
                                    return roles.some((r_3) => {
                                        if (r_3.CompanyId === x_11.CompanyId) {
                                            if (r_3.RoleId === Role__get_Identifier(new Role(3, []))) {
                                                return true;
                                            }
                                            else {
                                                return r_3.RoleId === Role__get_Identifier(new Role(6, []));
                                            }
                                        }
                                        else {
                                            return false;
                                        }
                                    });
                                }
                            })), {
                                Compare: comparePrimitives,
                            })), (selectedVessel = tryFind((tupledArg_1) => (tupledArg_1[0] === activity.VesselId), vesselOptions), append(singleton_1(MuiHelpers_createElement(Autocomplete, [["noOptionsText", "Ingen fartøy"], ["disabled", vesselOptions.length === 0], ["openOnFocus", true], ["selectOnFocus", true], ["clearOnBlur", true], ["handleHomeEndKeys", true], ["options", Array.from(vesselOptions)], ["getOptionLabel", (tuple_2) => tuple_2[1]], ["isOptionEqualToValue", (x_15) => ((y_3) => equals(x_15[0], y_3[0]))], ["style", {
                                flexGrow: 1,
                                maxWidth: 400,
                            }], ["value", selectedVessel], ["onChange", (_arg_11, v_3, _arg_1_2) => {
                                const newActivity_1 = new Activity(activity.Id, defaultArg(map((tuple_3) => tuple_3[0], v_3), -1), activity.RouteId, activity.WholeDay, activity.FromDate, activity.ToDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType);
                                setActivity(newActivity_1);
                                if (validateActivity(newActivity_1)) {
                                    setError(undefined);
                                }
                            }], ["renderInput", (p_1) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p_1), delay(() => append(singleton_1(["error", (error != null) && (activity.VesselId < 0)]), delay(() => append(singleton_1(["required", true]), delay(() => append(singleton_1(["variant", "outlined"]), delay(() => append(singleton_1(["color", "primary"]), delay(() => singleton_1(["label", "Fartøy"]))))))))))))))]])), delay(() => (!isSuperAdmin ? singleton_1(createElement("span", {
                                style: {
                                    fontStyle: "italic",
                                    fontSize: 0.85 + "rem",
                                },
                                children: "Du kan kun registrere aktiviteter for selskaper hvor du har rollen Driftspersonell i selskapet",
                            })) : empty_1())))))) : (empty_1())), delay(() => {
                                let elements_4, elements_3;
                                return append(singleton_1(MuiHelpers_createElement(FormControl, [["variant", "outlined"], ["fullWidth", true], (elements_4 = [MuiHelpers_createElement(InputLabel, [["children", "Aktivitetstype"]]), MuiHelpers_createElement(Select, [["label", "Aktivitetstype"], ["variant", "outlined"], ["fullWidth", true], ["value", defaultArg(map(int32ToString, activity.ActivityType), "")], ["onChange", (e_3, _arg_12) => {
                                    const x_17 = e_3.target.value;
                                    setActivity(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, activity.FromDate, activity.ToDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, map(Activity_ActivityType__get_Id, tryFind((y_4) => (Activity_ActivityType__get_Id(y_4) === x_17), Activity_ActivityType_AllActivityTypes()))));
                                }], (elements_3 = map_1((x_19) => MuiHelpers_createElement(MenuItem, [["value", Activity_ActivityType__get_Id(x_19)], ["children", toString_1(x_19)]]), Activity_ActivityType_AllActivityTypes()), ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])), delay(() => {
                                    let elems_7;
                                    return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-evenly",
                                    }], (elems_7 = [commonCheckBox("Bekreftet", activity.Confirmed, (x_20) => {
                                        setActivity(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, activity.FromDate, activity.ToDate, activity.InfoText, x_20, activity.VesselAvailable, activity.ActivityType));
                                    }), commonCheckBox("Fartøy tilgjengelig", activity.VesselAvailable, (x_21) => {
                                        setActivity(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, activity.FromDate, activity.ToDate, activity.InfoText, activity.Confirmed, x_21, activity.ActivityType));
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => append(singleton_1(createElement(DateRangePicker, {
                                        wholeDay: activity.WholeDay,
                                        fromDate: parseDateIso8601(activity.FromDate),
                                        toDate: unwrap(map(parseDateIso8601, activity.ToDate)),
                                        activity: activity,
                                        setValue: setActivity,
                                    })), delay(() => {
                                        let elems_8;
                                        return append(singleton_1(createElement("div", createObj(singleton((elems_8 = [commonCheckBox("Hele dagen", activity.WholeDay, (newWholeDay) => {
                                            setActivity(new Activity(activity.Id, activity.VesselId, activity.RouteId, newWholeDay, activity.FromDate, activity.ToDate, activity.InfoText, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_8))]))))), delay(() => {
                                            let elems_9;
                                            return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }], (elems_9 = toList(delay(() => {
                                                const currentStatus = HistoricState_CalculateFromDates(parseDateIso8601(activity.FromDate), map(parseDateIso8601, activity.ToDate));
                                                return append(singleton_1(MuiHelpers_createElement(Typography, [["style", {
                                                    marginRight: 5 + "px",
                                                }], ["children", "Status basert på valgte datoer: "]])), delay(() => append(singleton_1(createElement("span", {
                                                    style: {
                                                        marginRight: 5,
                                                        display: "inline-block",
                                                        width: 1 + "em",
                                                        height: 1 + "em",
                                                        backgroundColor: HistoricState__get_ColorCode(currentStatus),
                                                        borderRadius: 50 + "%",
                                                    },
                                                })), delay(() => singleton_1(toString_1(currentStatus))))));
                                            })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => append(singleton_1(MuiHelpers_createElement(TextField, [["fullWidth", true], ["multiline", true], ["minRows", "3"], ["label", "Beskrivelse"], ["value", activity.InfoText], ["onChange", (e_4) => {
                                                setActivity(new Activity(activity.Id, activity.VesselId, activity.RouteId, activity.WholeDay, activity.FromDate, activity.ToDate, e_4.target.value, activity.Confirmed, activity.VesselAvailable, activity.ActivityType));
                                            }]])), delay(() => singleton_1(ErrorHandling_errorBanner(error, () => {
                                                setError(undefined);
                                            }))))));
                                        }));
                                    }))));
                                }));
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])), delay(() => {
                        let children_3;
                        return singleton_1((children_3 = ofArray([MuiHelpers_createElement(Button, [["children", "Avbryt"], ["onClick", (_arg_14) => {
                            onClose(undefined);
                        }]]), MuiHelpers_createElement(Button, toList(delay(() => ((editActivityOpt != null) ? append(singleton_1(["children", "Lagre"]), delay(() => singleton_1(["onClick", (_arg_15) => {
                            updateActivity(activity, (_arg_16) => {
                                if (_arg_16.tag === 0) {
                                    onClose(_arg_16.fields[0]);
                                }
                                else {
                                    setError(_arg_16.fields[0]);
                                }
                            });
                        }]))) : append(singleton_1(["children", "Legg til"]), delay(() => singleton_1(["onClick", (_arg_17) => {
                            if (validateActivity(activity)) {
                                createActivity(activity, (_arg_18) => {
                                    if (_arg_18.tag === 0) {
                                        onClose(_arg_18.fields[0]);
                                    }
                                    else {
                                        setError(_arg_18.fields[0]);
                                    }
                                });
                            }
                            else if ((activity.RouteId < 0) ? true : (activity.VesselId < 0)) {
                                setError("Samband og fartøy må være valgt for å registrere aktivitet");
                            }
                            else {
                                setError("Ugyldige datoer");
                            }
                        }])))))))]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_3))]])));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_12))]));
        }));
    })))))))));
}

export function EditModal(act, onClose, onDelete, vessels, routes) {
    return createElement(ActivityModal, {
        editActivityOpt: act,
        onClose: onClose,
        onActivityDelete: onDelete,
        "vessels\'": unwrap(vessels),
        "routes\'": unwrap(routes),
    });
}

export function AddModal(defVessel, defRoute, defStartTime, onClose, vessels, routes) {
    return createElement(ActivityModal, {
        defaultVesselId: unwrap(defVessel),
        defaultRouteId: unwrap(defRoute),
        defaultStartTime: unwrap(defStartTime),
        onClose: onClose,
        "vessels\'": unwrap(vessels),
        "routes\'": unwrap(routes),
    });
}

//# sourceMappingURL=ActivityModal.js.map
